import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { TokenInterceptor } from './guards/token.interceptor';
import { importProvidersFrom } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';
import { FnfToastComponent } from './components/controls/fnf-toast/fnf-toast.component';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { ViewStateReuseStrategy } from './utils/view-state-reuse.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([TokenInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // A nav tap on the open page reopens it on its defaults (view state in the URL).
    { provide: RouteReuseStrategy, useClass: ViewStateReuseStrategy },
    provideHttpClient(),
    provideAnimations(),
    importProvidersFrom(
      ToastrModule.forRoot({
        toastComponent: FnfToastComponent,
        toastClass: 'fnf-toast',
        timeOut: 4000,
        extendedTimeOut: 2000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        resetTimeoutOnDuplicate: true,
        countDuplicates: true,
        includeTitleDuplicates: true,
        closeButton: true,
        // The card has an explicit close button, so a stray click on the
        // message no longer throws the notification away.
        tapToDismiss: false,
        // Keep the stack to the four cards the design shows; older toasts
        // give way so the newest is always visible.
        maxOpened: 4,
        autoDismiss: true,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        easeTime: 240,
      }),
    ),
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    provideCharts(withDefaultRegisterables()),
  ],
};
